/* eslint no-template-curly-in-string: 0 */

import achIconBank from '../../assets/images/ach-logo-bank.webp';
import achIconTransfer from '../../assets/images/ach-logo-bank-transfer.webp';
import { PAYMENT_NETWORKS, FLOW_TYPES } from '../../utils/enums';

export const ach = {
  id: PAYMENT_NETWORKS.ACH_FINIX,
  displayName: 'ACH FINIX',
  paywall: {
    tile: {
      displayName: ['ACH Transfer'],
      tagline: ['Direct deposit to your bank account'],
      description:
        'Deposit funds directly to your bank account. Expect 1-2 business days for funds to be available.',
      // btnLabel: "Go",
      logo: achIconBank,
    },
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.COLLECT_ACH_DETAILS_STREET_ADDRESS,
    title: 'ACH Transfer',
    description: [
      {
        string:
          'All payments are sent securely with encryption. Your account information is not retained and will only be used for this one-time transaction. ',
      },
      // {
      //   string:
      //     'Please confirm your bank account details to receive a direct deposit. Expect 1-2 business days for funds to be available OR to receive your money instantly, ',
      // },
      // {
      //   type: 'a',
      //   string: 'please select another option.',
      //   props: {
      //     className: 'hyperlink',
      //   },
      //   action: 'startOver',
      // },
    ],
  },
  acceptPayment: {
    title: ['Confirm Payment'],
    autoAcceptDurationInSeconds: 10,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.CONFIRM_ACH_DETAILS,
    description:
      'Please confirm that your bank details are correct as they appear below.',
    btnLabel: 'SUBMIT',
    secondaryText:
      'Click "Back" to edit your details or "Confirm" to submit your payment.',
  },
  networkSelectionAccepted: {
    imgSrc: achIconTransfer,
    title: ['Success!'],
    description: [
      'Please check your email ',
      {
        string: '${payment.recipientNotificationPreference}',
        transformations: [
          {
            type: 'formatEmailAddressOrMobilePhoneNumber',
          },
        ],
        props: {
          className: 'payment-recipientEmail',
        },
      },
      ' for details regarding your ',
      {
        string: '${paymentNetwork.displayName}',
        props: {
          className: 'payment-paymentNetwork',
        },
      },
      ' for ',
      {
        string: '${payment.acceptedAmount}',
        transformations: [
          {
            type: 'formatAsCurrency',
            data: {
              currency: '${payment.acceptedCurrency}',
            },
          },
        ],
        props: {
          className: 'payment-amount',
        },
      },
      '. Your funds should be available within 1-2 business days.',
    ],
    secondaryText: ' ',
  },
  paymentComplete: {
    title: 'Payment Complete',
    initial: {
      description: [
        'Success! A deposit in the amount of ',
        {
          string: '${payment.acceptedAmount}',
          transformations: [
            {
              type: 'formatAsCurrency',
              data: {
                currency: '${payment.acceptedCurrency}',
              },
            },
          ],
          props: {
            className: 'payment-amount',
          },
        },
        ' will be deposited to your bank account within 1-2 business days.',
      ],
      secondaryText: [
        'A confirmation will be ',
        {
          string: '${payment.recipientNotificationPreference}',
          transformations: [
            {
              type: 'formatPaymentNetworkRecipientType',
            },
          ],
        },
        {
          string: '${payment.recipientNotificationPreference}',
          transformations: [
            {
              type: 'formatEmailAddressOrMobilePhoneNumber',
            },
          ],
          props: {
            className: 'payment-recipientEmail',
          },
        },
        '.',
      ],
    },
    revisit: {
      description: [
        'Please check your email ',
        {
          string: '${payment.recipientEmail}',
          props: {
            className: 'payment-recipientEmail',
          },
        },
        ' for details regarding your payment for ',
        {
          string: '${payment.acceptedAmount}',
          transformations: [
            {
              type: 'formatAsCurrency',
              data: {
                currency: '${payment.acceptedCurrency}',
              },
            },
          ],
          props: {
            className: 'payment-amount',
          },
        },
        '.',
      ],
      secondaryText: ' ',
    },
    imgSrc: achIconTransfer,
  },
};

export default ach;
